import { Injectable } from '@angular/core';
import { ApiHttpClientService } from '../../api-http-client.service';
import { environment } from 'src/environments/environment';
import { Linha } from 'src/app/models/api/comercial/linha';
import { IResponse } from 'src/app/models/api/response.interface';

@Injectable({
  providedIn: 'root'
})
export class ApiLinhaService {
  private baseUrl = 'Linha';
  private controller: ApiHttpClientService;

  constructor(
    private api: ApiHttpClientService
  ) {
    this.controller = this.api
      .useBaseUrl(environment.microservice.comercial)
      .useBaseUrl(this.baseUrl);
  }

  getAll() {
    return this.controller.unwrap().get<Linha[]>('');
  }
  getAllAtivosInativos() {
    return this.controller.useLoading('waves').get<IResponse<Linha[]>>('/BuscarAtivosInativos');
  }
  insert(data: Linha) {
    return this.controller.useLoading().post('', data);
  }

  update(data: Linha) {
    return this.controller.useLoading().put('', data);
  }

  delete(id: string) {
    if (!id) { throw new Error('Invalid Argument'); }
    return this.controller.useLoading().delete(id);
  }
}
